(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9896],{

/***/ 79896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content052": function() { return /* binding */ Content052; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87367);
/* harmony import */ var _Content052_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40411);
/* harmony import */ var _Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var Content052 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2, ref3;
    var ref4;
    var title = (ref4 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var blocks = (ref5 = payload === null || payload === void 0 ? void 0 : payload.blocks) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    var attachment = (ref6 = payload === null || payload === void 0 ? void 0 : payload.attachment) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    var type = (ref7 = payload === null || payload === void 0 ? void 0 : (ref = payload.button) === null || ref === void 0 ? void 0 : ref.type) !== null && ref7 !== void 0 ? ref7 : "form";
    var ref8;
    var buttonText = (ref8 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.buttonText) !== null && ref8 !== void 0 ? ref8 : "";
    var ref9;
    var link = (ref9 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.button) === null || ref2 === void 0 ? void 0 : ref2.link) !== null && ref9 !== void 0 ? ref9 : "";
    var ref10;
    var form = (ref10 = payload === null || payload === void 0 ? void 0 : (ref3 = payload.button) === null || ref3 === void 0 ? void 0 : ref3.form) !== null && ref10 !== void 0 ? ref10 : {};
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("052", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.CONTENT */ .R.CONTENT);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().query;
    var ref11 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useToggle */ .OT)(), opened = ref11.opened, onOpen = ref11.onOpen, onClose = ref11.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().blocks),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().left),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading3 */ .aC, {
                                as: "h3",
                                className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                children: title
                            }),
                            type === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Action */ .aU, {
                                onClick: onOpen,
                                className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                            color: "brand",
                                            appearance: "bigger",
                                            children: buttonText
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                                link: link,
                                className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().play),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrow),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                            className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon),
                                            name: "arrow_right"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                            color: "brand",
                                            appearance: "bigger",
                                            children: buttonText
                                        })
                                    ]
                                })
                            }),
                            opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ModalWrapper */ .AB, {
                                onCloseModal: onClose,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                    item: form,
                                    metaData: {
                                        page: query.slug
                                    },
                                    instanceId: instanceId,
                                    onReset: onClose
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().right),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .OrderedList */ .GS, {
                                items: blocks,
                                className: (_Content052_module_scss__WEBPACK_IMPORTED_MODULE_8___default().list),
                                appearance: "bold"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .DownloadFile */ .xn, {
                                file: attachment,
                                label: t("download_file")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content052);


/***/ }),

/***/ 40411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content052_wrapper__KkEfQ","blocks":"Content052_blocks__y7Ah4","left":"Content052_left__6NYyZ","right":"Content052_right__m_zUh","title":"Content052_title__G_BI7","list":"Content052_list__Eolwd","arrow":"Content052_arrow__J_9L0","play":"Content052_play__UyZWh","icon":"Content052_icon__Coiwh"};

/***/ })

}]);